(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("eight-colors", [], factory);
	else if(typeof exports === 'object')
		exports["eight-colors"] = factory();
	else
		root["eight-colors"] = factory();
})(self, () => {
return 